export default __webpack_public_path__ + "static/media/logo.da69f158.png";